import { mapGetters } from 'vuex';

const borderWidth = '3px';

export default {

  computed: {
    ...mapGetters('users', { getUser: 'get' }),

    defaultBorderColor() {
      return this.$vuetify.theme.currentTheme.secondary;
    },
  },

  methods: {
    getBorderStyle(userId, color) {
      const borderColor = color
        || (_.get(this.getUser(userId), 'color') || this.defaultBorderColor);
      return { 'box-shadow': `0 0 0 ${borderWidth} ${borderColor}` };
    },
  },
};
